import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import moment from 'moment';
Vue.filter('datediff', function (date) {
  var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hh mm';
  return moment(date).fromNow();
});